import React, { useEffect, useState } from "react";







import I from "../component/Icon";







import BC from "../component/Breadcrumb";







import apiService from "../services/apiService";















const TEACHER_API_BASE = "Teacher";







const GET_ALL_SCHOOL_API = "School/getAllSchool";











const showNotification = (type, message) => {



  if (



    typeof document === "undefined" ||



    typeof window === "undefined"



  ) {



    return;



  }







  const existingNotification =



    document.getElementById(



      "teacher-form-notification"



    );







  if (existingNotification) {



    existingNotification.remove();



  }







  const notification =



    document.createElement("div");







  notification.id =



    "teacher-form-notification";







  notification.textContent =



    `${type === "success" ? "✓" : "✕"} ${message}`;







  Object.assign(



    notification.style,



    {



      position: "fixed",



      top: "20px",



      right: "20px",



      zIndex: "99999",



      minWidth: "280px",



      maxWidth: "420px",



      padding: "12px 16px",



      borderRadius: "8px",



      backgroundColor:



        type === "success"



          ? "#d1e7dd"



          : "#f8d7da",



      color:



        type === "success"



          ? "#0f5132"



          : "#842029",



      border:



        type === "success"



          ? "1px solid #badbcc"



          : "1px solid #f5c2c7",



      fontSize: "14px",



      fontWeight: "600",



      boxShadow:



        "0 4px 12px rgba(0,0,0,0.15)",



    }



  );







  document.body.appendChild(



    notification



  );







  window.setTimeout(() => {



    if (notification.parentNode) {



      notification.remove();



    }



  }, 3000);



};







const getApiErrorMessage = (



  error,



  fallback



) => {



  const data =



    error?.response?.data;







  if (



    typeof data === "string" &&



    data.trim()



  ) {



    return data;



  }







  if (



    data &&



    typeof data === "object"



  ) {



    if (



      data?.errors &&



      typeof data.errors === "object"



    ) {



      const validationErrors =



        Object.values(data.errors)



          .flat()



          .filter(Boolean)



          .join(" ");







      if (validationErrors) {



        return validationErrors;



      }



    }







    return (



      data?.message ||



      data?.Message ||



      data?.failureReason ||



      data?.FailureReason ||



      data?.title ||



      data?.error ||



      error?.message ||



      fallback



    );



  }







  return (



    error?.message ||



    fallback



  );



};















export default function TeacherForm({







  title,







  initial,







  onSave,







  onBack,







}) {







  // Support both the new separate name fields and old records that only have `name`.







  const legacyFullName =







    initial?.name ??







    initial?.Name ??







    "";















  const legacyNameParts = legacyFullName







    .trim()







    .split(/\s+/)







    .filter(Boolean);















  const legacyFirstName = legacyNameParts[0] || "";







  const legacyLastName =







    legacyNameParts.length > 1







      ? legacyNameParts[legacyNameParts.length - 1]







      : "";







  const legacyMiddleName =







    legacyNameParts.length > 2







      ? legacyNameParts.slice(1, -1).join(" ")







      : "";















  const [f, setF] = useState({







    firstName:







      initial?.firstName ??







      initial?.FirstName ??







      legacyFirstName,







    middleName:







      initial?.middleName ??







      initial?.MiddleName ??







      legacyMiddleName,







    lastName:







      initial?.lastName ??







      initial?.LastName ??







      legacyLastName,







    mobile:







      initial?.mobile ??







      initial?.Mobile ??







      "",







    email:







      initial?.email ??







      initial?.Email ??







      "",







    school:







      initial?.school ??







      initial?.School ??







      initial?.schoolName ??







      initial?.SchoolName ??







      "",







    schoolId:







      initial?.schoolId ??







      initial?.SchoolId ??







      "",







    status:







      initial?.status ??







      initial?.Status ??







      ((initial?.isActive ?? initial?.IsActive) === false ||







        (initial?.isActive ?? initial?.IsActive) === 0







        ? "inactive"







        : "active"),







    altPhone:







      initial?.altPhone ??







      initial?.alternatePhone ??







      initial?.AlternatePhone ??







      "",







    pincode:







      initial?.pincode ??







      initial?.Pincode ??







      "",







    address:







      initial?.address ??







      initial?.Address ??







      "",







  });















  const [schools, setSchools] = useState([]);







  const [loading, setLoading] = useState(false);







  const [schoolLoading, setSchoolLoading] = useState(false);

  const [fieldErrors, setFieldErrors] = useState({});















  const s = (key, value) => {
    setF((prev) => ({
      ...prev,
      [key]: value,
    }));

    setFieldErrors((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  const normalizeSchool = (school) => ({







    ...school,







    id:







      school?.id ??







      school?.Id ??







      school?.schoolId ??







      school?.SchoolId,















    schoolName:







      school?.schoolName ??







      school?.SchoolName ??







      school?.name ??







      school?.Name ??







      "",















    isActive:







      school?.isActive ??







      school?.IsActive ??







      school?.status ??







      school?.Status ??







      true,







  });















  const fetchSchools = async () => {







    try {







      setSchoolLoading(true);















      const response = await apiService.get(







        GET_ALL_SCHOOL_API







      );















      const result = response.data;















      console.log(







        "Get All School Response:",







        result







      );















      const output =







        result?.output ??







        result?.Output ??







        result?.data ??







        result?.Data ??







        result;















      const schoolResult =







        output?.result ??







        output?.Result ??







        output?.data ??







        output?.Data ??







        output;















      const normalizedSchools =







        Array.isArray(schoolResult)







          ? schoolResult







            .map(normalizeSchool)







            .filter(







              (school) =>







                school.id &&







                school.schoolName &&







                school.isActive === true







            )







          : [];















      console.log(







        "Teacher Form Schools:",







        normalizedSchools







      );















      setSchools(normalizedSchools);







    } catch (error) {







      console.error(







        "School Load Error:",







        error







      );















      setSchools([]);















      const apiError = error?.response?.data;















      showNotification(



        "error",



        getApiErrorMessage(



          error,



          "Unable to load schools"



        )



      );







    } finally {







      setSchoolLoading(false);







    }







  };















  useEffect(() => {







    fetchSchools();







  }, []);















  const handleSchoolChange = (val) => {







    if (val === "__add_new__") {







      window.location.href = "/schools";







      return;







    }















    if (!val) {







      setF((prev) => ({







        ...prev,







        schoolId: "",







        school: "",







      }));







      return;







    }















    const schoolId = Number(val);















    const selectedSchool = schools.find(







      (school) => Number(school.id) === schoolId







    );















    setF((prev) => ({







      ...prev,







      schoolId,







      school: selectedSchool?.schoolName || "",







    }));







  };















  const validateForm = () => {
    const e = {};

    if (!f.firstName.trim()) {
      e.firstName = "First name is required";
    }

    if (!f.lastName.trim()) {
      e.lastName = "Last name is required";
    }

    if (!f.mobile.trim()) {
      e.mobile = "Mobile number is required";
    } else if (f.mobile.length !== 10) {
      e.mobile = "Please enter valid 10 digit mobile number";
    }

    if (!f.schoolId) {
      e.schoolId = "School is required";
    }
    if (!f.email.trim()) {
      e.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(f.email.trim())) {
      e.email = "Enter a valid email";
    }

    if (f.altPhone && f.altPhone.length !== 10) {
      e.altPhone = "Please enter valid 10 digit alternate phone number";
    }

    if (f.pincode && f.pincode.length !== 6) {
      e.pincode = "Please enter valid 6 digit pincode";
    }

    return e;
  };

  const saveTeacher = async () => {
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setFieldErrors(validationErrors);
      return;
    }

    setFieldErrors({});

    const isEdit = Boolean(







      initial?.id ?? initial?.Id







    );



    try {







      setLoading(true);



      const commonPayload = {







        schoolId: Number(f.schoolId),







        firstName: f.firstName.trim(),







        middleName: f.middleName?.trim() || "",







        lastName: f.lastName.trim(),







        address: f.address?.trim() || "",







        pincode: f.pincode?.trim() || "",



        mobile: f.mobile?.trim() || "",



        alternatePhone: f.altPhone?.trim() || "",



        email: f.email?.trim() || "",



        dob:



          initial?.dob ??



          initial?.DOB ??



          null,



        gender:



          initial?.gender ??



          initial?.Gender ??



          null,



      };



      const payload = isEdit







        ? {







          id: Number(







            initial?.id ??







            initial?.Id







          ),















          ...commonPayload,















          isActive:







            f.status === "active"







              ? 1







              : 0,







        }







        : {







          ...commonPayload,















          isActive:







            f.status === "active",







        };















      console.log(







        isEdit







          ? "Update Teacher Payload:"







          : "Add Teacher Payload:",







        payload







      );















      let response;















      if (isEdit) {







        response = await apiService.put(







          `${TEACHER_API_BASE}/updateTeacher`,







          payload







        );







      } else {







        response = await apiService.post(







          `${TEACHER_API_BASE}/addTeacher`,







          payload







        );







      }















      const result = response.data;



      console.log(

        isEdit

          ? "Update Teacher Response:"

          : "Add Teacher Response:",

        result

      );



      const output = result?.output ?? result?.Output;

      const outputStatus = output?.status ?? output?.Status ?? "";

      const outputMessage = output?.message ?? output?.Message ?? "";

      const statusText = String(outputStatus).toLowerCase();

      const messageText = String(outputMessage).toLowerCase();

      const isDuplicate =

        statusText.includes("duplicate") ||

        (messageText.includes("already") && messageText.includes("exist"));



      if (isDuplicate) {

        showNotification("error", outputMessage || "Teacher already exists.");

        return;

      }



      if (

        result?.isSuccess === false ||

        result?.IsSuccess === false

      ) {

        throw new Error(

          outputMessage ||

          result?.failureReason ||

          result?.FailureReason ||

          result?.message ||

          result?.Message ||

          (isEdit ? "Failed to update teacher" : "Failed to add teacher")

        );

      }



      showNotification(



        "success",



        isEdit



          ? "Teacher updated successfully"



          : "Teacher added successfully"



      );















      if (onSave) {







        onSave({







          ...f,















          firstName: f.firstName.trim(),







          middleName: f.middleName?.trim() || "",







          lastName: f.lastName.trim(),















          id: isEdit







            ? Number(







              initial?.id ??







              initial?.Id







            )







            : result?.id ??







            result?.Id ??







            result?.output?.id ??







            result?.Output?.Id,















          schoolId: Number(f.schoolId),















          school: f.school,















          alternatePhone:







            f.altPhone?.trim() || "",















          isActive:







            f.status === "active",







        });







      }















      if (onBack) {







        onBack();







      }







    } catch (error) {







      console.error(







        "Update/Add Teacher Error:",







        error







      );















      console.log(







        "Backend Error Response:",







        error?.response?.data







      );















      console.log(







        "Backend Status:",







        error?.response?.status







      );















      const message =



        getApiErrorMessage(



          error,



          isEdit



            ? "Unable to update teacher"



            : "Unable to add teacher"



        );







      showNotification(



        "error",



        message



      );







    } finally {







      setLoading(false);







    }







  };















  const renderFieldError = (name) => {
    if (!fieldErrors?.[name]) return null;

    return (
      <div
        style={{
          color: "#dc2626",
          fontSize: 10.5,
          marginTop: 4,
        }}
      >
        {fieldErrors[name]}
      </div>
    );
  };

  return (







    <>







      <BC items={["Teachers", title]} onBack={onBack} />















      <div className="card cp" style={{ maxWidth: 720 }}>







        <div







          style={{







            fontWeight: 700,







            fontSize: 15,







            marginBottom: 18,







          }}







        >







          {title}







        </div>















        <div className="fsec">







          <div className="fsec-t">







            <I n="briefcase" s={14} c="var(--p)" />







            Professional Details







          </div>















          <div className="fgrid">







            <div className="fg">







              <label className="fl">First Name *</label>







              <input







                className="fi"







                value={f.firstName}







                onChange={(e) =>







                  s("firstName", e.target.value)







                }







                placeholder="e.g. Priya"







              />
              {renderFieldError("firstName")}







            </div>















            <div className="fg">







              <label className="fl">Middle Name</label>







              <input







                className="fi"







                value={f.middleName}







                onChange={(e) =>







                  s("middleName", e.target.value)







                }







                placeholder="e.g. Sunil"







              />







            </div>















            <div className="fg">







              <label className="fl">Last Name *</label>







              <input







                className="fi"







                value={f.lastName}







                onChange={(e) =>







                  s("lastName", e.target.value)







                }







                placeholder="e.g. Sharma"







              />
              {renderFieldError("lastName")}







            </div>















            <div className="fg">







              <label className="fl">Mobile *</label>







              <input







                className="fi"







                type="tel"







                value={f.mobile}







                maxLength={10}







                onChange={(e) =>







                  s(







                    "mobile",







                    e.target.value.replace(/\D/g, "")







                  )







                }







                placeholder="9876543210"







              />
              {renderFieldError("mobile")}







            </div>















            <div className="fg">







              <label className="fl">Email</label>







              <input







                className="fi"







                type="email"







                value={f.email}







                onChange={(e) =>







                  s("email", e.target.value)


                }
                placeholder="teacher\\@example.com"
              />
              {renderFieldError("email")}
            </div>

            <div className="fg">







              <label className="fl">School *</label>















              <select







                className="fi"







                value={f.schoolId}







                disabled={schoolLoading}







                onChange={(e) =>







                  handleSchoolChange(e.target.value)







                }







              >







                <option value="">







                  {schoolLoading







                    ? "Loading schools..."







                    : "Select school…"}







                </option>















                {schools.map((school) => (







                  <option







                    key={school.id}







                    value={school.id}







                  >







                    {school.schoolName}







                  </option>







                ))}







              </select>
              {renderFieldError("schoolId")}







            </div>







          </div>







        </div>















        <div className="fsec">







          <div className="fsec-t">







            <I n="person" s={14} c="var(--p)" />







            Personal Details







          </div>















          <div className="fgrid">







            <div className="fg">







              <label className="fl">







                Alternate Phone







              </label>







              <input







                className="fi"







                type="tel"







                value={f.altPhone}







                maxLength={10}







                onChange={(e) =>







                  s(







                    "altPhone",







                    e.target.value.replace(/\D/g, "")







                  )







                }







                placeholder="Alternate mobile"







              />
              {renderFieldError("altPhone")}







            </div>















            <div className="fg">







              <label className="fl">Pincode</label>







              <input







                className="fi"







                value={f.pincode}

                maxLength={6}

                onChange={(e) =>

                  s(

                    "pincode",

                    e.target.value.replace(/\D/g, "")

                  )

                }

                placeholder="411001"

              />
              {renderFieldError("pincode")}

            </div>

            <div className="fg fall">

              <label className="fl">Address</label>

              <input

                className="fi"

                value={f.address}

                onChange={(e) =>

                  s("address", e.target.value)

                }

                placeholder="City, State"

              />

            </div>

          </div>

        </div>

        <div style={{ display: "flex", gap: 9 }}>

          <button

            type="button"

            className="btn btn-p"

            onClick={saveTeacher}

            disabled={loading || schoolLoading}

          >

            <I n="check" s={13} c="#fff" />

            {loading

              ? "Saving..."

              : initial

                ? "Update Teacher"

                : "Add Teacher"}

          </button>

          <button

            type="button"

            className="btn btn-g"

            onClick={onBack}

            disabled={loading}

          >

            Cancel

          </button>

        </div>

      </div>

    </>

  );

}